import { Pipe, PipeTransform } from '@angular/core';
import { Extension } from '../models/centrex/extension';
import { ExtensionTypes } from '../models/centrex/enums/extension-types';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'extensionDisplay',
    standalone: true
})
export class ExtensionDisplayPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(extension: Extension): string {
    return extension ? extension.number + ' - ' + (extension.type === ExtensionTypes.service ? extension.service : extension.name) + (extension.type === ExtensionTypes.group ? ` (${this.translate.instant('Common.Group')})` : ''): '';
  }

}
